/**
 * FIQ-1554: true when the register's asset data has changed since the last
 * explicit mapping run, i.e. the "your data has changed" banner should show.
 * Registers that have never been mapped (or have no recorded change) are not
 * stale - the first-run settings flow covers those.
 * @param {{assetsChangedAt?: string, lastMappedAt?: string}} [freshness]
 */
export function isMappingStale(freshness) {
    // freshness is null/undefined while the query loads or when the register is missing
    const { assetsChangedAt, lastMappedAt } = freshness ?? {}
    if (!assetsChangedAt || !lastMappedAt) return false
    return new Date(assetsChangedAt).getTime() > new Date(lastMappedAt).getTime()
}
